<div class="enin-backdrop enin-splash text-center">
  <div class="splash-screen-fadein" style="text-align: center">
    <img alt="enin-logo" class="enin-logo" height="54" src="app/assets/img/logo_slogan_black.svg" />

    <p class="mt-3">
      {{ 'sso_login.heading_to_login_page' | translate }}<br />
      <small class="mt-3">
        {{ 'sso_login.heading_to_login_page_hint_1' | translate }}
        <a [routerLink]="['/login']" class="underline">{{ 'sso_login.heading_to_login_page_hint_2' | translate }}</a>
      </small>
    </p>
  </div>
</div>
